import React from "react"
import { Helmet } from "react-helmet"

const SEO = ({ title, description, keywords }) => {
  return (
    <Helmet title={`${title} | Aion Therapeutic`}>
      <html lang="en" />
      <meta name="desctiption" content={`${description}`} />
      <meta name="keywords" content={`${keywords}`} />
    </Helmet>
  )
}

export default SEO
